import './style.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { permission } from '@/directives/permission'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.directive('permission', permission)
app.mount('#app')
